export default {
  data() {
    return {
      overdueThirtyPageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
      overdueThirtyData: [],
      overdueThirtyColumns: [
        {
          title: '客户编号',
          width: 120,
          dataIndex: 'code',
        },
        {
          title: '客户名称',
          width: 220,
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '逾期总金额(元)',
          width: 200,
          dataIndex: 'overdue',
        },
        {
          title: '最长逾期天数',
          width: 200,
          dataIndex: 'maxDay',
        },
      ],
      overdueThirtyTableLoading: true,
      expirationLimitPageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
      expirationLimitData: [],
      expirationLimitColumns: [
        {
          title: '客户编号',
          width: 120,
          dataIndex: 'code',
        },
        {
          title: '客户名称',
          width: 220,
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '额度类型',
          width: 220,
          dataIndex: 'typeStr',
        },
        {
          title: '额度金额(元)',
          width: 200,
          dataIndex: 'amount',
        },
        {
          title: '最近到期日',
          width: 200,
          dataIndex: 'indateEnd',
        },
      ],
      expirationLimitTableLoading: true,
      expirationLoanPageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
      expirationLoanData: [],
      expirationLoanColumns: [
        {
          title: '客户编号',
          width: 120,
          dataIndex: 'companyCode',
        },
        {
          title: '客户名称',
          width: 220,
          scopedSlots: { customRender: 'companyName' },
          dataIndex: 'companyName',
        },
        {
          title: '担保类型',
          width: 200,
          dataIndex: 'typeStr',
        },
        {
          title: '担保金额(元)',
          width: 200,
          dataIndex: 'validAmount',
        },
        {
          title: '最近到期日',
          width: 200,
          dataIndex: 'expireDate',
        },
      ],
      expirationLoanTableLoading: true,
      insureanceLoanPageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
      insureanceLoanData: [],
      insureanceLoanColumns: [
        {
          title: '客户编号',
          width: 120,
          dataIndex: 'companyCode',
        },
        {
          title: '客户名称',
          width: 220,
          scopedSlots: { customRender: 'companyName' },
          dataIndex: 'companyName',
        },
        {
          title: '保险金额(元)',
          width: 200,
          dataIndex: 'amount',
        },
        {
          title: '最近到期日',
          width: 200,
          dataIndex: 'expireDate',
        },
      ],
      insureanceLoanTableLoading: true,
      riskData: [],
      riskColumns: [
        {
          title: '客户编号',
          width: 120,
          dataIndex: 'companyCode',
        },
        {
          title: '客户名称',
          width: 220,
          scopedSlots: { customRender: 'companyName' },
          dataIndex: 'companyName',
        },
        {
          title: '已生效限额(元)',
          width: 220,
          dataIndex: 'limitAmount',
        },
        {
          title: '担保金额(元)',
          width: 200,
          dataIndex: 'validAmount',
        },
      ],
      riskTableLoading: true,
      riskPageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
      riskINSUData: [],
      riskINSUColumns: [
        {
          title: '客户编号',
          width: 120,
          dataIndex: 'companyCode',
        },
        {
          title: '客户名称',
          width: 220,
          scopedSlots: { customRender: 'companyName' },
          dataIndex: 'companyName',
        },
        {
          title: '已生效限额(元)',
          width: 220,
          dataIndex: 'limitAmount',
        },
        {
          title: '保险金额(元)',
          width: 200,
          dataIndex: 'amount',
        },
      ],
      riskINSUTableLoading: true,
      riskINSUPageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
      loanData: [],
      loanColumns: [
        {
          title: '客户编号',
          width: 120,
          dataIndex: 'code',
        },
        {
          title: '客户名称',
          width: 220,
          scopedSlots: { customRender: 'name' },
          dataIndex: 'name',
        },
        {
          title: '总信用限额(元)',
          width: 220,
          dataIndex: 'limitAmount',
        },
        {
          title: '当前有效额度(元)',
          width: 200,
          dataIndex: 'validAmount',
        },
      ],
      loanTableLoading: true,
      loanPageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
    }
  },
  methods: {
    handleOverdueThirtyClickPage({ current, pageSize }) {
      this.overdueThirtyPageData = {
        ...this.overdueThirtyPageData,
        current,
        pageSize,
      }
      this._getOverdueThirty()
    },
    handleRiskINSUClickPage({ current, pageSize }) {
      this.riskINSUPageData = {
        ...this.riskINSUPageData,
        current,
        pageSize,
      }
      this._getRiskData()
    },
    handleExpirationLimitClickPage({ current, pageSize }) {
      this.expirationLimitPageData = {
        ...this.expirationLimitPageData,
        current,
        pageSize,
      }
      this._getExpirationLimit()
    },
    handleExpirationLoanClickPage({ current, pageSize }) {
      this.expirationLoanPageData = {
        ...this.expirationLoanPageData,
        current,
        pageSize,
      }
      this._getExpirationLoan()
    },
    handleInsureanceLoanClickPage({ current, pageSize }) {
      this.insureanceLoanData = {
        ...this.insureanceLoanData,
        current,
        pageSize,
      }
      this._getInsureanceLoan()
    },
    handleLoanClickPage({ current, pageSize }) {
      this.loanPageData = {
        ...this.loanPageData,
        current,
        pageSize,
      }
      this._getLoanData()
    },
    handleRiskClickPage({ current, pageSize }) {
      this.riskPageData = {
        ...this.riskPageData,
        current,
        pageSize,
      }
      this._getRiskData()
    },
  },
}
